import { ReactElement } from 'react';

import { ReceptionServiceDuration } from '@dreryk/egabinet-private-medical-service-published-language-api';

import { TestableComponentProps, Text } from '@dreryk/react-components';

type DurationProps = {
   value: ReceptionServiceDuration;
   min?: never;
   max?: never;
};

type DurationRangeProps = {
   min: ReceptionServiceDuration;
   max: ReceptionServiceDuration;
   value?: never;
};

type DurationTextProps = TestableComponentProps & (DurationProps | DurationRangeProps);

export const DurationText = (props: DurationTextProps): ReactElement | null => {
   const minValue = props.min?.asMinutes() ?? props.value!.asMinutes();
   const maxValue = props.max?.asMinutes() ?? props.value!.asMinutes();

   return (
      <Text testId={props.testId}>{minValue === maxValue ? `${minValue} min` : `${minValue}-${maxValue} min`}</Text>
   );
};
